module.exports = __webpack_public_path__ + "static/media/menu-icon.798b2c45.svg";